export function formatAnswer(value: unknown): string {
  if (value === null || value === undefined) return '-'
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return String(value)
  }
  if (Array.isArray(value)) return value.map(formatAnswer).join(', ')
  if (typeof value === 'object' && 'answer' in value) return formatAnswer(value.answer)
  return JSON.stringify(value)
}
